import { hasAccess } from "@woven/contracts";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useAuth } from "../auth/context";
import { SignInModal } from "../components/SignInModal";
import { LoadingState } from "../components/StatusView";

export function SignInPage() {
  const { user, loading, access, error, accessRequested } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (loading) {
    return <LoadingState label="Checking session…" />;
  }

  if (user) {
    if (error || accessRequested === null || !hasAccess(access, "lite")) {
      return <Navigate to="/sign-up" replace />;
    }
    const state = location.state as { from?: string } | null;
    return <Navigate to={state?.from ?? "/console"} replace />;
  }

  return <SignInModal onClose={() => navigate("/")} />;
}
